import $ from 'jquery';

const timeline = () => {
    const owlTimeline = $('.timeline.owl-carousel');

    if (owlTimeline.length > 0) {
        owlTimeline.owlCarousel({
            loop: false,
            nav: true,
            dots: false,
            responsive: {
                0: {
                    items: 1,
                    margin: 0,
                    stagePadding: 0
                },
                768: {
                    items: 2,
                    margin: 60,
                    stagePadding: 60
                },
                985: {
                    items: 4,
                }
            }
        });

        $('.timeline .date').on('hover', function(){
            var _this = $(this);

            $('.timeline .date').each(function(){
                $(this).removeClass('hover');
            });

            _this.addClass('hover');
        });

        owlTimeline.on('mousewheel', '.owl-stage', function (e) {
            if (e.deltaY>0) {
                owlTimeline.trigger('next.owl');
            } else {
                owlTimeline.trigger('prev.owl');
            }
            e.preventDefault();
        });
    }
}

export default timeline;
